import { AccountingOpenPostPostingsService_openPostPostingsServiceGetQuery } from '@festina/moneyin-general-types/moneyin/hooks/AccountingOpenPostPostingsService_openPostPostingsServiceGetQuery'

export const useLazyFetchMoneyInPostings =
  AccountingOpenPostPostingsService_openPostPostingsServiceGetQuery.useLazyQuery
